import {
  getTelegramCloudItem,
  removeTelegramCloudItem,
  setTelegramCloudItem,
} from '@/utils/telegramCloudStorage'

export const PENDING_PAYMENT_KEY = 'pendingPayment'

export async function getPendingPayment() {
  const data = await getTelegramCloudItem(PENDING_PAYMENT_KEY, null)
  if (!data || typeof data !== 'object') {
    return null
  }
  return data
}

export async function setPendingPayment(data) {
  if (!data) {
    return removePendingPayment()
  }
  return setTelegramCloudItem(PENDING_PAYMENT_KEY, data)
}

export async function removePendingPayment() {
  return removeTelegramCloudItem(PENDING_PAYMENT_KEY)
}
